import { registerBlockType } from '@wordpress/blocks';
import './style.scss';
import './editor.scss';
import Edit from './edit';
import save from './save';
import metadata from './block.json';
import advancejson from '@vayu-blocks/advance-panel/advance.json';
import indexjson from './edit.json';
import { FaTimeline } from "react-icons/fa6";

registerBlockType( metadata.name, {
	...metadata,
	attributes: {...indexjson, ...advancejson},
	edit: Edit,
	icon: <FaTimeline  style={{color:'#6c1bc3',transform:'rotate(90deg)'}} />,
	save,
} );


